import React from 'react';
import OrdersHistory from 'components/commercetools-ui/account/details/sections/orders';

const AccountOrdersHistoryTastic: React.FC = () => {
  return <OrdersHistory />;
};

export default AccountOrdersHistoryTastic;
